import { render, staticRenderFns } from "./PenyebaranNota.vue?vue&type=template&id=68e43eae&scoped=true&"
import script from "./PenyebaranNota.vue?vue&type=script&lang=js&"
export * from "./PenyebaranNota.vue?vue&type=script&lang=js&"
import style0 from "./PenyebaranNota.vue?vue&type=style&index=0&id=68e43eae&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e43eae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VDataTable,VIcon,VRow,VTextField})
